import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faKey, faLock } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import * as userActions from "../../redux/user/userActions"
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import URLPage from '../../endPoints/endpoints';



function Login ({title}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({
    mail: '',
    password: ''
    });

    const [validations, setValidations] = useState(''); 
    const [eye , setEye] = useState(false)

    const handleEye = () => {
      if (eye) {
        setEye(false);
        return
      } else {
        setEye(true);
      }
    }

    const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
     if (title == 'Administrator') 
  {
  
   axios.post(`${URLPage}/api/auth/login-admin`, credentials)
  .then(response => {
    
    dispatch(userActions.setCurrentUser(response.data));
  
   navigate("/admin/list-users");
    return  
  
  })
  .catch(error => {
  
   
   return setValidations('mail/password incorrect');
  });
} else {

   
   axios.post(`${URLPage}/api/auth/login`, credentials)
  .then(response => {
    
    dispatch(userActions.setCurrentUser(response.data));
  
    navigate("/dashboard");
    return  
  
  })
  .catch(error => {
  
   
   return setValidations('mail/password incorrect');
  });

} 

  };
   
   return <>

   <div  style={{ width: '95%', margin: '0 auto' }}>

   <div data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
   <div className='container-form'>
  <h1>{title}</h1> 
  <form onSubmit={handleSubmit}>
  <h2>Login <FontAwesomeIcon icon={faKey} /></h2>
  <div className="form-group">
  <label htmlFor="exampleInputEmail1">Mail</label>
  <input 
    type="email" 
    name='mail'
    value={credentials.email}
    onChange={handleChange}
    className="form-control"
    id="exampleInputEmail1" 
    aria-describedby="emailHelp" 
    placeholder="Enter email"
    onClick={()=> setValidations('')}
    required/>
    <small id="emailHelp" className="form-text text-danger">{validations}</small>
   </div>
 <div className="form-group">
  
 <label htmlFor="exampleInputPassword1">Password</label>
 <div className="input-group">
 <input 
    type={eye ? 'text' : 'password'}
    name='password'
    autoComplete="current-password"
    value={credentials.password}
    onChange={handleChange}
    className="form-control" 
    
    placeholder="Password"
    onClick={()=> setValidations('')}
    required/>
       <button onClick={handleEye} className="btn  button-password" type="button">
        <FontAwesomeIcon icon={eye ? faEye : faEyeSlash} />
      </button>
 </div>
</div>
 <div className='container-button'>
     <button type="submit" className="btn btn-primary" >Submit</button>
</div>

</form>
</div>
     </div>
   </div>
  </>  
}

export default Login







